export default "__VITE_ASSET__CUkwwfPx__"